//import { Table } from "react-bootstrap";
import React from "react";
import { useCollection } from '@cloudscape-design/collection-hooks';
import { Table, TextFilter, Pagination, CollectionPreferences, PropertyFilter,Spinner,TextContent  } from '@cloudscape-design/components';
import { useHistory,useLocation  } from "react-router-dom";
import { Formatter } from "../format";
import { Placeholder } from "./Placeholder";
import { SentimentIcon } from "./SentimentIcon";
import { TrendIcon } from "./TrendIcon";
import "./ContactTable.css";
import { DateTimeForm, formatDateTime } from './DateTimeForm';
import { ContactTablePreferences, DEFAULT_PREFERENCES } from './ContactTablePreferences'
import { useLocalStorage } from '../common/localStorage';
import Popover from "@cloudscape-design/components/popover";
import Button from "@cloudscape-design/components/button";
import StatusIndicator from "@cloudscape-design/components/status-indicator";
import Icon from "@cloudscape-design/components/icon";
import Link from "@cloudscape-design/components/link";
import { list } from "../api/api";
import {getKeyExt}  from "../routes/Home";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

const config = window.pcaSettings;





const COLUMN_DEFINITIONS = [
  {
    id: "timestamp",
    header: "Timestamp",
    sortingField: "timestamp",
    cell: (d) => {
      if(d.status !== undefined && d.status.length > 0 && d.status !== "Done") {
        return (
            Formatter.Timestamp(d.timestamp)
        )
      }
      else {
        return (
            <Link href={`/dashboard/${d.key}`}>{Formatter.Timestamp(d.timestamp)}</Link>
        )
      }
    },
    minWidth: 160
  },
  {
    id: "jobName",
    header: "Job Name",
    cell: (d) => {
      if(d.status !== undefined && d.status.length > 0 && d.status !== "Done") {
        return (
            d.jobName
        )
      }
      else {
        return (
            <Link variant="primary" href={`/dashboard/${d.key}`}>{d.jobName}</Link>
        )
      }
    },
    isRowHeader: true,
    sortingField: "jobName",
  },
  {
    id: "status",
    header: "Status",
    cell: (d) => d.status,
    isRowHeader: true,
    sortingField: "status",
    minWidth:130
  },
  {
    id: "guid",
    header: "GUID",
    cell: (d) => d.guid,
    isRowHeader: true,
    sortingField: "guid",
    minWidth:150
  },
  {
    id: "agent",
    header: "Agent",
    cell: (d) => d.agent,
    isRowHeader: true,
    sortingField: "agent",
    minWidth:130
  },
  {
    id: "customer",
    header: "Customer",
    cell: (d) => d.customer,
    isRowHeader: true,
    sortingField: "customer",
    minWidth:130
  },
  {
    id: "queue",
    header: "Queue",
    cell: (d) => d.queue,
    isRowHeader: true,
    sortingField: "queue",
    minWidth:130
  },
  {
    id: "summary_resolved",
    header: "Resolved",
    cell: (d) => d.summary_resolved,
    isRowHeader: true,
    sortingField: "summary_resolved",
    minWidth:130
  },
  {
    id: "summary_topic",
    header: "Topic",
    cell: (d) => d.summary_topic,
    isRowHeader: true,
    sortingField: "summary_topic",
    Width:130
  },
  {
    id: "summary_product",
    header: "Product",
    cell: (d) => d.summary_product,
    isRowHeader: true,
    sortingField: "summary_product",
    minWidth:130
  },
  {
    id: "summary_summary",
    header: "Summary",
    cell: (d) => {
      //console.log(d);
      if (d.summary_summary !== undefined) {
        return (
          <Popover
            dismissButton={false}
            position="top"
            size="large"
            triggerType="text"
            content={d.summary_summary}
          >
            {(d.summary_summary.length > 20 ? d.summary_summary.substring(0, 20) + "..." : d.summary_summary)}
          </Popover>
          /*
          <ExpandableSection headerText={(d.summary_summary.length > 50 ? d.summary_summary.substring(0,50) + "..." : d.summary_summary )}>
            {d.summary_summary}
          </ExpandableSection>*/
        )
      }
      return 'n/a';
    },
    isRowHeader: true,
    sortingField: "summary_summary",
    minWidth:200
  },
  {
    id: "callerSentimentScore",
    header: "Cust Sent",
    sortingField: "callerSentimentScore",
    cell: (d) => (
      <div className="d-flex justify-content-evenly">
        <SentimentIcon score={d?.callerSentimentScore} />
        <TrendIcon trend={d.callerSentimentChange} />
      </div>
    ),
    minWidth: 130
  },
  {
    id: "langCode",
    header: <div className="col-header-wrapper text-left">Lang Code</div>,
    cell: (d) => d.lang,
    minWidth: 100,
  },
  {
    id: "duration",
    header: <div className="col-header-wrapper text-left">Duration</div>,
    cell: (d) => Formatter.Time(d.duration),
    minWidth: 130,
  }
];

const getMatchesCountText = function getMatchesCountText(count) {
 
  let getFetcher= localStorage.getItem("fetcherOn") ? localStorage.getItem("fetcherOn") : "";
  //console.log(`@@@@@@@@@@@@@@@@@ getMatchesCountText count ${count} and getFetcher ${getFetcher}`)
  if(getFetcher=="true")
  {
    return count === 1 ? `1 match` : `${count} matches`;
  }
  else
  {
    localStorage.setItem("fetcherOn","false");
    return "Please wait, retrieving data";
  }
}


const Loading = () =>
  COLUMN_DEFINITIONS.map((c, i) => (
    <td key={i}>
      <Placeholder />
    </td>
  ));

const NoMatches = ({ children }) => (
  <tr>
    <td colSpan={COLUMN_DEFINITIONS.length}>
      <div className="d-flex justify-content-center py-4">{children}</div>
    </td>
  </tr>
);

export const ContactTable = ({ data = [], loading = false, empty, header, variant='embedded' }) => {
  const history = useHistory();
  
  
  const [preferences, setPreferences] = useLocalStorage(
    'contact-table-preferences',
    DEFAULT_PREFERENCES,
  );

  const onClickDetail = (e) => {
    //console.log('onClickDetail')
    //console.log(e);
    history.push(`/dashboard/${e.detail.item.key}`);
  };
  const onClick = async (e) => {
    //console.log('@@ OnClick on ContactTable')
    //console.log(e);
    let optsObj={};
    let opts=[];
    localStorage.setItem("fetcherOn","false");
    if(Array.isArray(e.tokens))
    {
      if(e.tokens.length==0)
      {
        localStorage.removeItem('opts');
        localStorage.removeItem('cacheList')
        localStorage.removeItem('countList');
        localStorage.removeItem('fetcherOn');
        sessionStorage.removeItem('opts');
        sessionStorage.removeItem('cacheList')
        sessionStorage.removeItem('countList');
        sessionStorage.removeItem('fetcherOn');
        setTimeout(()=>{
          window.location.reload(false);
       }, 500);
      }
      else
      {
        let opts=[];
        e.tokens.forEach(function (element, index, array) {
          let optsObj={};
          
          //console.log(`index ${index} element ${JSON.stringify(element)} operation ${e.operation}`);
          if(element.propertyKey.indexOf('timestamp')>=0)
          {
              let epochTime= Formatter.ConvertEPOCH(element.value)
              optsObj[element.propertyKey]=`${epochTime}`;
              optsObj['operator']=`${element.operator}`;
          }
          else
          {
              let elval =element.value.replaceAll("+","");
              let operator = element.operator;
              optsObj['entity#'+element.propertyKey]=`${elval}`;
              switch(operator)
              {
                  case "=":
                  optsObj['operator'] = "equal";
                  break;
                  case ":":
                  default:
                  optsObj['operator'] = "contains";
                  break;                  
              }
          }
          opts.push(optsObj)
        });
        config.opts=opts;
        //console.log(`StartKey: ${result.StartKey} timeStampFrom: ${result.timestampFrom}`)

        //getKeyExt();
        history.replace(`/Home`)
        history.push(`/Home`)

        

      }

    }
    
    //console.log(`StartKey: ${result.StartKey} timeStampFrom: ${result.timestampFrom}`)
    //getKeyExt();
    history.replace(`/Home`)
    history.push(`/Home`)


  };



  const [
    callQuery,
    setCallQuery
  ] = React.useState({
    tokens: [],
    operation: "and"
  });


  const { items, actions, filteredItemsCount, collectionProps, paginationProps, propertyFilterProps } = useCollection(
    data,
    {
      propertyFiltering: {
        filteringProperties: [
          {
            key: "timestamp",
            defaultOperator: '>',
            operators: ['<', '<=', '>', '>='].map(operator => ({
              operator,
              form: DateTimeForm,
              format: formatDateTime,
              match: 'datetime',
            })),
            propertyLabel: "Timestamp",
            groupValuesLabel: "Timestamps"
          },
          {
            key: "jobname",
            defaultOperator: ':',
            operators: [':',"="],
            propertyLabel: "Job Name",
            groupValuesLabel: "Job Names"
          },
          /*{
            key: "guid",
            defaultOperator: ':',
            operators: [':'],
            propertyLabel: "GUID (contains)",
            groupValuesLabel: "GUIDs"
          },*/
          {
            key: "agent",
            defaultOperator: ':',
            operators: [':',"="],
            propertyLabel: "Agent",
            groupValuesLabel: "Agents"
          },
          {
            key: "customer",
            defaultOperator: ':',
            operators: [':',"="],
            propertyLabel: "Customer",
            groupValuesLabel: "Customers"
          },
          /*{
            key: "agentid",
            defaultOperator: ':',
            operators: [":"],
            propertyLabel: "AgentId (begins with)",
            groupValuesLabel: "AgentIds"
          },
          {
            key: "agentid",
            defaultOperator: '=',
            operators: ["="],
            propertyLabel: "AgentId (equals)",
            groupValuesLabel: "AgentIds"
          }*/
          /*{
            key: "queue",
            defaultOperator: ':',
            operators: [':'],
            propertyLabel: "Queue (contains)",
            groupValuesLabel: "Queues"
          },
          {
            key: "summary_resolved",
            defaultOperator: ':',
            operators: [":"],
            propertyLabel: "Resolved (contains)",
            groupValuesLabel: "Resolved"
          },
          {
            key: "summary_topic",
            defaultOperator: ':',
            operators: [":"],
            propertyLabel: "Topic (contains)",
            groupValuesLabel: "Topics"
          },
          {
            key: "summary_product",
            defaultOperator: ':',
            operators: [":"],
            propertyLabel: "Product (contains)",
            groupValuesLabel: "Products"
          },
          {
            key: "lang",
            defaultOperator: ':',
            operators: [":"],
            propertyLabel: "Language Code (contains)",
            groupValuesLabel: "Languages Codes"
          }*/
          /*{
            key: "duration",
            defaultOperator: '>',
            operators: ['<', '<=', '>', '>='],
            propertyLabel: "Duration",
            groupValuesLabel: "Durations"
          }*/
        ],
        
        empty: (
          <div>No Calls.</div>
        ),
        noMatch: (
          <div>No matches.</div>
        )
      },
      pagination: { pageSize: preferences.pageSize ? preferences.pageSize: 10 },
      sorting: {},
      selection: {},
    });

  return (
    <Table
      {...collectionProps}
      header={header}
      variant={variant}
      columnDefinitions={COLUMN_DEFINITIONS}
      columnDisplay={preferences.contentDisplay}
      items={items}
      pagination={<Pagination {...paginationProps} />}
      resizableColumns={true}
      //loading={getMatchesCountText(filteredItemsCount)=="Please wait, retrieving data"?true:false}
      //loadingText={getMatchesCountText(filteredItemsCount)}
      //onSelectionChange={onClick} fransiska 2024 08 30
      // onRowClick={onClickDetail} fransiska 2024 08 30
      // selectionType="single"
      stickyHeader={true}
      stickyColumns={{ first: 2, last: 0 }}
      filter={
        <PropertyFilter
          {...propertyFilterProps}
          onChange={({ detail }) => {
            //console.log('onChange filter>>')
            //console.log(detail);
           
            onClick(detail)
            setCallQuery(detail);
          }}
          hideOperations
          query={callQuery}
          i18nStrings={{
            filteringAriaLabel: "your choice",
            dismissAriaLabel: "Dismiss",
            filteringPlaceholder: "Find calls",
            groupValuesText: "Values",
            groupPropertiesText: "Properties",
            operatorsText: "Operators",
            operationAndText: "and",
            operationOrText: "or",
            operatorLessText: "Less than",
            operatorLessOrEqualText: "Less than or equal",
            operatorGreaterText: "Greater than",
            operatorGreaterOrEqualText:
              "Greater than or equal",
            operatorContainsText: "Begins with",
            operatorDoesNotContainText: "Does not contain",
            operatorEqualsText: "Equals",
            operatorDoesNotEqualText: "Does not equal",
            editTokenHeader: "Edit filter",
            propertyText: "Property",
            operatorText: "Operator",
            valueText: "Value",
            cancelActionText: "Cancel",
            applyActionText: "Apply",
            allPropertiesLabel: "All properties",
            tokenLimitShowMore: "Show more",
            tokenLimitShowFewer: "Show fewer",
            clearFiltersText: "Clear filters",
            removeTokenButtonAriaLabel: token =>
              `Remove token ${token.propertyKey} ${token.operator} ${token.value}`,
            enteredTextLabel: text => `Use: "${text}"`
          }}
          //countText={getMatchesCountText(filteredItemsCount)=="Please wait, retrieving data" ?"" : getMatchesCountText(filteredItemsCount)}
          countText={getMatchesCountText(filteredItemsCount)}
          expandToViewport={true}
        />
      }

      preferences={
        <ContactTablePreferences preferences={preferences} setPreferences={setPreferences} />
      }
      visibleColumns={['jobName', ...preferences.visibleContent]}
    />
  );
};
